<template>
  <v-dialog :value="true" persistent max-width="600">
    <v-card>
      <v-card-title>Version summary</v-card-title>
      <v-divider/>

      <v-card-text>
        <v-container>
          <v-row align="center">
            <v-col cols="6" sm="4">
              <v-combobox label="Version" v-model="showVersion" outlined dense hide-details :items="versions" @change="getSummary()"/>
            </v-col>
            <v-col>Current: {{$store.state.version}}</v-col>
          </v-row>
        </v-container>
        <v-card outlined>
          <div style="height:250px" class="pa-3 overflow-y" v-html="versionSummary"/>
        </v-card>
      </v-card-text>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('done')">Done</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: 'VersionSummary',
  props: {
    version: {type:String, required:false}
  },
  data() {
    return {
      versions: [],
      showVersion: null,
      versionSummary: ''
    }
  },
  async created() {
    const results = await this.$apiCall(`query VersionSummary {
                                            versions
                                          }`,
                                        {});
    if (!results.error) {
      this.versions = results.data.versions;
      this.showVersion = this.version || this.versions[0];
      this.getSummary();
    }
  },
  methods: {
    async getSummary() {
      const results = await this.$apiCall(`query VersionSummary($version:String!) {
                                             versionSummary(version:$version)
                                           }`,
                                          {version:this.showVersion});
      if (!results.error)
        this.versionSummary = results.data.versionSummary;
    },
  }
}
</script>